import { useEffect, useState } from 'react'
import { slotsAPI } from '@hpanel/web-common/api/client'
import type { Slot } from '@hpanel/web-common/api/types'
import { toMessage } from './siteUi'

/** Load one of the tenant's sites by container id (the API lists; this picks the one). */
export function useSlot(containerId: number): { slot: Slot | null; loading: boolean; error: string | null } {
  const [slot, setSlot] = useState<Slot | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let live = true
    setLoading(true)
    slotsAPI
      .list()
      .then((r) => {
        if (!live) return
        const found = r.slots.find((s) => s.container_id === containerId) ?? null
        setSlot(found)
        setError(found ? null : `Site ${containerId} not found`)
      })
      .catch((e: unknown) => {
        if (live) setError(toMessage('load site', e, 'Failed to load the site'))
      })
      .finally(() => {
        if (live) setLoading(false)
      })
    return () => {
      live = false
    }
  }, [containerId])

  return { slot, loading, error }
}
